import onlineTheme from '@sunbit-dev/ui/src/components/themes/online';
import * as styles from './CardApplyStyles';
const theme = {
  ...onlineTheme,
  font: { ...onlineTheme.font, ...styles.fonts },
  colors: { ...onlineTheme.colors, ...styles.colors },
};

export type CardApplyThemeType = typeof theme;

export default theme;
